import { render, staticRenderFns } from "./UserPreviewPart.vue?vue&type=template&id=4c1f01d6&scoped=true&"
import script from "./UserPreviewPart.vue?vue&type=script&lang=js&"
export * from "./UserPreviewPart.vue?vue&type=script&lang=js&"
import style0 from "./UserPreviewPart.vue?vue&type=style&index=0&id=4c1f01d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f01d6",
  null
  
)

export default component.exports